import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {
	return {
		body: {
			padding      : "1rem 2rem",
			background   : theme.other.paletteNew.darkModeInclinedBlack1,
			borderRadius : "1rem"
		},
		content: {
			flexBasis     : "min( 30vw, 400px ) !important",
			borderRadius  : "1rem",
			boxShadow     : "none",
			background    : "none",
			maxHeight     : "500px",
			width         : "400px !important",
			padding       : "0.1rem !important",
			overflow      : "hidden",
			display       : "flex",
			flexDirection : "column",
			// position     : "relative"
			":after"      : {
				content         : "' '",
				position        : "absolute",
				left            : "50%",
				top             : "50%",
				height          : "1200px",
				width           : "1200px",
				backgroundImage : theme.other.paletteNew.proChipGradient,
				zIndex          : "-1",
				transform       : "translate(-50%, -50%)",
				animation       : "rotateProChip 10s linear infinite",

				"@keyframes rotateProChip": {
					"0%": {
						transform: "translate(-50%, -50%) rotate(0deg)"
					},
					"100%": {
						transform: "translate(-50%, -50%) rotate(360deg)"
					}
				}
			}
		},
		drawerBody: {
			background   : theme.other.paletteNew.darkModeInclinedBlack2,
			borderRadius : "1rem 1rem 0 0"
		},
		drawerContent: {
			borderRadius : "1rem 1rem 0 0",
			overflow     : "hidden",
			paddingTop   : "0.1rem !important",
			height       : "fit-content",
			position     : "relative",

			":after": {
				content         : "' '",
				position        : "absolute",
				left            : "50%",
				top             : "50%",
				height          : "1200px",
				width           : "1200px",
				backgroundImage : theme.other.paletteNew.proChipGradient,
				zIndex          : "-1",
				transform       : "translate(-50%, -50%)",
				animation       : "rotateProChip 10s linear infinite",

				"@keyframes rotateProChip": {
					"0%": {
						transform: "translate(-50%, -50%) rotate(0deg)"
					},
					"100%": {
						transform: "translate(-50%, -50%) rotate(360deg)"
					}
				}
			}

		},
		closeIconWrapper: {
			position : "absolute",
			top      : "2rem",
			right    : "2rem"
		},
		modalContentWrapper: {
			display       : "flex",
			flexDirection : "column",
			paddingTop    : "2rem",
			gap           : "2rem",
			alignItems    : "center",

			[rooterMediaQuery.mobile]: {
				padding: "2rem"
			}
		},
		title: {
			"& > * + *": {
				marginTop: "0.5rem"
			}
		},
		btnWrapper: {
			display       : "flex",
			width         : "100%",
			gap           : "0.5rem",
			flexDirection : "column"
		},
		topBtn: {
			background    : theme.other.paletteNew.proGradient,
			paddingInline : "0.8rem"
		},
		doneBtn: {
			fontSize : "1.6rem",
			padding  : "1rem"
		}
	};
} );